import React from 'react';
import CustomSection from '../../custom-general/custom-section';

import { CustomAutSummary } from '../../../../utils/models';

import classNames from './style.module.scss';

interface Props extends Pick<CustomAutSummary, 'recommendation' | 'conclusion'> {
	sectionTitle?: string;
	sectionSubtitle?: string;
}

const ExxonMobilAutSummarySheet: React.FC<Props> = ({
	recommendation,
	conclusion,
	sectionSubtitle,
	sectionTitle = "Summary",
}) => {
	return (
		<CustomSection sectionTitle={sectionTitle} sectionSubtitle={sectionSubtitle}>
			<div className="p-2">
				<div className={classNames.conclusion}>
					<div className={classNames.conclusionHeader}>Conclusion / Remark</div>
					<div className={classNames.conclusionBody}>{conclusion}</div>
				</div>

				<div className={classNames.recommendation}>
					<div className={classNames.recommendationHeader}>Recommendation, if any</div>
					<div className={classNames.recommendationBody}>{recommendation}</div>
				</div>
			</div>
		</CustomSection>
	);
};

export default ExxonMobilAutSummarySheet;
